import actionTypes from "../actions/actionTypes";

const initialState = {
  fees: {
    fees: [],
    totalAmount: []
  }
};

const summaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SUMMARY_SUCCESS:
      return {
        ...state,
        fees: action.payload
      };
    default:
      return state;
  }
};

export default summaryReducer;
